import { Component, EventEmitter, Output } from '@angular/core';

@Component({
  templateUrl: './resend.component.html',
  styleUrls: ['../../../style/global.css', './resend.component.css'],
  selector: 'app-register-resend',
})
export class ResendComponent {
  @Output() navigate = new EventEmitter<void>();

  doNavigate() {
    this.navigate.emit();
  }
}
